import { DesignerFeatures } from '@/types';
import { CoreActionTypes, FeaturesSetAction } from '../types';

export const setFeaturesAction = (features: Partial<DesignerFeatures>): FeaturesSetAction => ({
  type: CoreActionTypes.FEATURES_SET,
  features,
});
